"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Small = function (_a) {
    var id = _a.id, fill = _a.fill, title = _a.title, background = _a.background, rest = __rest(_a, ["id", "fill", "title", "background"]);
    var fillId = 'facebookGradient' + (id || '');
    var fillReference = "url(#" + fillId + ")";
    if (fill) {
        fillReference = fill;
    }
    return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 36 36", version: "1.1", fill: fillReference }, rest),
        title && react_1.default.createElement("title", null, title),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("linearGradient", { x1: "50%", x2: "50%", y1: "97.0782153%", y2: "0%", id: fillId },
                react_1.default.createElement("stop", { offset: "0%", stopColor: "#0062E0" }),
                react_1.default.createElement("stop", { offset: "100%", stopColor: "#19AFFF" }))),
        react_1.default.createElement("circle", { cx: "18", cy: "18", r: "18", stroke: "none" }),
        react_1.default.createElement("path", { fill: "#FFFFFF", d: "M25 23l.8-5H21v-3.5c0-1.4.5-2.5 2.7-2.5H26V7.4c-1.3-.2-2.7-.4-4-.4-4.1 0-7 2.5-7 7v4h-4.5v5H15v12.7c1 .2 2 .3 3 .3s2-.1 3-.3V23h4z" })));
};
var Facebook = function (props) {
    var id = props.id, height = props.height, width = props.width, fill = props.fill, title = props.title, background = props.background, _a = props.max, max = _a === void 0 ? 45.5 : _a, children = props.children, rest = __rest(props, ["id", "height", "width", "fill", "title", "background", "max", "children"]);
    var fillId = 'facebookGradient' + (id || '');
    var fillReference = "url(#" + fillId + ")";
    if (fill) {
        fillReference = fill;
    }
    var retract = 0;
    var maxRadius = max;
    var radius = maxRadius;
    var defaultWidth = 100;
    var defaultHeight = 100;
    if (typeof width === 'number' && typeof height === 'number') {
        defaultWidth = width;
        defaultHeight = height;
        radius = width / 2;
    }
    else if (typeof width === 'number') {
        radius = width / 2;
        defaultWidth = width;
        defaultHeight = width;
    }
    else if (typeof height === 'number') {
        radius = height / 2;
        defaultWidth = height;
        defaultHeight = height;
    }
    var showChildren = children && radius > 57;
    if (showChildren) {
        if (radius - maxRadius < 25) {
            retract = radius - maxRadius;
        }
        maxRadius = 22;
    }
    if (radius > maxRadius) {
        return (react_1.default.createElement("svg", __assign({ width: defaultWidth, height: defaultHeight, viewBox: "0 0 " + defaultWidth + " " + defaultHeight, fill: fillReference, version: "1.1" }, rest),
            title && react_1.default.createElement("title", null, title),
            react_1.default.createElement("defs", null,
                react_1.default.createElement("linearGradient", { x1: "50%", x2: "50%", y1: "97.0782153%", y2: "0%", id: fillId },
                    react_1.default.createElement("stop", { offset: "0%", stopColor: "#0062E0" }),
                    react_1.default.createElement("stop", { offset: "100%", stopColor: "#19AFFF" }))),
            background ? (react_1.default.createElement("rect", { width: defaultWidth, height: defaultHeight })) : (react_1.default.createElement("circle", { cx: radius, cy: radius, r: radius })),
            react_1.default.createElement("g", { transform: "translate(" + (defaultWidth / 2 - maxRadius) + "," + (defaultHeight / 2 - maxRadius - retract) + ")" },
                react_1.default.createElement(Small, __assign({ id: id + '-inner', width: maxRadius * 2, height: maxRadius * 2, fill: "none" }, rest))),
            showChildren && (react_1.default.createElement("g", { transform: "translate(" + radius + "," + (radius + maxRadius + 28 - retract) + ")" },
                react_1.default.createElement("text", { textAnchor: "middle", fontSize: 14, fill: "#fff" }, children)))));
    }
    return (react_1.default.createElement(Small, __assign({ id: id, width: width, height: height, fill: fill, title: title }, rest)));
};
exports.default = Facebook;
